/*
  ALU Store — catálogo de colección (sections/alu-main-collection.liquid).
  Filtros, orden, chips y paginación recargan solo la sección con la Section
  Rendering API y actualizan la URL. En móvil los filtros viven en un drawer.
*/
(() => {
  if (customElements.get('alu-collection')) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mobileQuery = window.matchMedia('(max-width: 820px)');

  class AluCollection extends HTMLElement {
    connectedCallback() {
      if (this.redirectLegacyType()) return;
      this.bind();
    }

    /* Enlaces antiguos del menú: /collections/x?type=mouse → /collections/x/type-mouse */
    redirectLegacyType() {
      const params = new URLSearchParams(window.location.search);
      const type = params.get('type');
      if (!type) return false;
      const chip = this.querySelector(`[data-type-tag="type-${CSS.escape(type.toLowerCase())}"]`);
      if (!chip) return false;
      window.location.replace(chip.href);
      return true;
    }

    bind() {
      this.form = this.querySelector('[data-filter-form]');
      this.panel = this.querySelector('[data-filter-panel]');
      this.backdrop = this.querySelector('[data-filter-backdrop]');
      this.openButton = this.querySelector('[data-filter-open]');

      this.openButton?.addEventListener('click', () => this.toggleDrawer(true));
      this.querySelector('[data-filter-close]')?.addEventListener('click', () => this.toggleDrawer(false));
      this.backdrop?.addEventListener('click', () => this.toggleDrawer(false));

      if (this.form) {
        // Cambios en filtros y orden: recarga inmediata en desktop; en el drawer
        // móvil también, para actualizar el contador del botón "Ver N productos".
        this.addEventListener('change', (event) => {
          if (!event.target.form || event.target.form !== this.form) return;
          if (event.target.type === 'number') return;
          this.submitForm();
        });
        this.addEventListener('input', (event) => {
          if (event.target.form !== this.form || event.target.type !== 'number') return;
          window.clearTimeout(this.priceTimer);
          this.priceTimer = window.setTimeout(() => this.submitForm(), 700);
        });
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.submitForm({ closeDrawer: true });
        });
      }

      // Chips, filtros activos y paginación: sin recargar la página.
      this.addEventListener('click', (event) => {
        const link = event.target.closest('a[data-filter-link], .alu-chip');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;
        event.preventDefault();
        const scroll = link.closest('.alu-pagination') !== null;
        this.load(link.href, { scroll });
      });

      this.onKey = (event) => {
        if (event.key === 'Escape' && this.classList.contains('filters-open')) this.toggleDrawer(false);
      };
      document.addEventListener('keydown', this.onKey);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
      document.body.style.overflow = '';
    }

    toggleDrawer(open) {
      this.classList.toggle('filters-open', open);
      if (this.backdrop) this.backdrop.hidden = !open;
      this.openButton?.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) this.panel?.querySelector('button, input, a')?.focus();
    }

    submitForm({ closeDrawer = false } = {}) {
      const params = new URLSearchParams(new FormData(this.form));
      // Quita los campos vacíos (precio sin valor) para no ensuciar la URL.
      [...params.keys()].forEach((key) => {
        if (params.get(key) === '') params.delete(key);
      });
      const url = `${this.dataset.baseUrl}?${params.toString()}`;
      this.load(url, { closeDrawer });
    }

    async load(url, { scroll = false, closeDrawer = false } = {}) {
      const keepDrawer = this.classList.contains('filters-open') && !closeDrawer && mobileQuery.matches;
      const focusedName = document.activeElement?.name;
      const focusedValue = document.activeElement?.value;
      this.setAttribute('aria-busy', 'true');

      try {
        const target = new URL(url, window.location.origin);
        target.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(target.toString());
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('alu-collection');
        if (!fresh) throw new Error('Respuesta sin catálogo');

        target.searchParams.delete('section_id');
        window.history.pushState({ aluCollection: true }, '', target.toString());

        document.body.style.overflow = '';
        this.replaceWith(fresh);
        if (keepDrawer) fresh.toggleDrawer(true);
        if (focusedName) {
          const selector = `[name="${CSS.escape(focusedName)}"]${focusedValue ? `[value="${CSS.escape(focusedValue)}"]` : ''}`;
          fresh.querySelector(selector)?.focus({ preventScroll: true });
        }
        if (scroll) {
          fresh.querySelector('.alu-catalog-toolbar')?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        }
      } catch (error) {
        console.error('[alu-collection] Recarga parcial falló, navegando normal', error);
        window.location.href = url;
      }
    }
  }

  customElements.define('alu-collection', AluCollection);

  // Atrás/adelante del navegador después de filtrar: recarga la vista de esa URL.
  window.addEventListener('popstate', () => {
    if (document.querySelector('alu-collection')) window.location.reload();
  });
})();
